// Cookie Policy - English version

export const cookieContentEN = {
  title: 'Cookie Policy',
  lastUpdated: 'Last updated: 06.11.2025',
  
  sections: [
    {
      id: 'what-are-cookies',
      title: '1. What are cookies?',
      content: 'Cookies are small text files that websites store on your device to improve user experience and analyze web traffic. Cookies do not harm your device and do not contain viruses.'
    },
    {
      id: 'types',
      title: '2. What cookies do we use?',
      types: [
        {
          name: 'Essential Cookies',
          description: 'These cookies are necessary for the website to function and cannot be disabled.',
          items: ['Session management', 'Security and authentication', 'Form data storage'],
          retention: 'Until end of session'
        },
        {
          name: 'Analytics Cookies',
          description: 'Help us understand how visitors use the site.',
          items: [
            { name: 'Google Analytics 4', description: 'Traffic and user behavior analysis' },
            { name: 'Hotjar', description: 'User experience analysis and heatmaps' }
          ],
          retention: 'Up to 2 years',
          privacy: 'https://policies.google.com/privacy'
        },
        {
          name: 'Marketing Cookies',
          description: 'Used for targeted advertising and remarketing.',
          items: [
            { name: 'Facebook Pixel', description: 'Ad optimization and remarketing' }
          ],
          retention: 'Up to 2 years',
          privacy: 'https://www.facebook.com/privacy/policy'
        },
        {
          name: 'Functional Cookies',
          description: 'Provide advanced features and personalization.',
          items: [
            { name: 'ChatGPT widget', description: 'AI assistant' },
            'Language and preference storage'
          ],
          retention: 'Up to 1 year'
        }
      ]
    },
    {
      id: 'manage',
      title: '3. How to manage cookies?',
      content: 'You can manage cookies through our settings or through your browser settings. Please note that disabling cookies may affect website functionality.',
      buttonText: 'Open cookie settings'
    },
    {
      id: 'legal',
      title: '4. Legal basis',
      intro: 'The use of cookies is based on:',
      items: [
        'General Data Protection Regulation (GDPR)',
        'Estonian Electronic Communications Act § 104',
        'Your consent (except essential cookies)'
      ]
    },
    {
      id: 'contact',
      title: '5. Contact',
      intro: 'For questions regarding cookies, please contact us:',
      company: 'Polyus Plus OÜ',
      address: 'Uuslinna 11, Tallinn, Estonia',
      linkText: 'Contact via contact form'
    }
  ]
};
